import { InputTag } from 'mixs/base/input_mixin';
import { deepmerge } from 'utilities/merge';
export class Input extends InputTag {
  defaultOpts = {
    negative_value: 0,
    positive_value: 1,
    class: 'checkbox-color checkbox-success'
  }
  init(){
    this.opts = deepmerge(this.defaultOpts, this.opts)
    super.init();
    this.watch();
  }
}

riot.mixin('inputs.checkbox-switch', Input as riot.TagMixin)
